<div *ngIf="loader" class="fixed inset-0 flex items-center justify-center bg-white z-50">
  <div class="text-center">
    <div class="animate-spin rounded-full h-16 w-16 border-b-2 border-[#655BE7] mx-auto"></div>
    <p class="mt-4 text-gray-500 text-sm" [style.font-family]="'var(--vex-font)'">Loading Result...</p>
  </div>
</div>

<div *ngIf="!loader" class="p-6 bg-gray-50 min-h-screen">

  <div *ngIf="!results" class="flex flex-col items-center justify-center py-24">
    <img src="../../../../../../assets/img/no-data-images/general.png" alt="No data" class="w-40 object-contain mb-4"/>
    <p class="text-gray-500 text-base font-medium" [style.font-family]="'var(--vex-font)'">No result data found.</p>
  </div>

  <ng-container *ngIf="results">

    <div class="card rounded-2xl shadow-sm overflow-hidden mb-6">
      <div class="bg-gradient-to-r from-[#655BE7] to-indigo-400 px-6 py-5 flex items-center gap-4">
        <div class="w-12 h-12 rounded-full bg-white/20 text-white flex items-center justify-center flex-shrink-0 text-lg">
          <i class="fa-solid fa-user-graduate"></i>
        </div>
        <div>
          <h2 class="text-base font-bold text-white" [style.font-family]="'var(--vex-font)'">Student Details</h2>
          <p class="text-xs text-purple-200 mt-0.5" [style.font-family]="'var(--vex-font)'">
            {{ results?.student_result_details?.semester_year }}&nbsp;&nbsp;|&nbsp;&nbsp;Examination:&nbsp;{{ results?.student_result_details?.exam_month }}&nbsp;{{ results?.student_result_details?.exam_year }}
          </p>
        </div>
      </div>

      <div class="p-6 space-y-6">

        <div>
          <div class="flex items-center gap-2 mb-3">
            <span class="w-5 h-5 rounded-md bg-purple-100 text-[#655BE7] flex items-center justify-center text-xs flex-shrink-0">
              <i class="fa-solid fa-user"></i>
            </span>
            <span class="text-xs font-bold text-[#655BE7] uppercase tracking-widest" [style.font-family]="'var(--vex-font)'">Personal Info</span>
          </div>
          <div class="grid grid-cols-2 md:grid-cols-4 gap-3">
            <div class="bg-gray-50 rounded-xl p-3.5 border border-gray-100 hover:border-purple-200 hover:bg-purple-50 transition-colors duration-150">
              <p class="text-xs text-gray-400 mb-1" [style.font-family]="'var(--vex-font)'">Student Name</p>
              <p class="text-sm font-semibold text-gray-800 leading-snug" [style.font-family]="'var(--vex-font)'">{{ results?.student_result_details?.student_name || '-' }}</p>
            </div>
            <div class="bg-gray-50 rounded-xl p-3.5 border border-gray-100 hover:border-purple-200 hover:bg-purple-50 transition-colors duration-150">
              <p class="text-xs text-gray-400 mb-1" [style.font-family]="'var(--vex-font)'">Admission No.</p>
              <p class="text-sm font-semibold text-gray-800 leading-snug" [style.font-family]="'var(--vex-font)'">{{ results?.student_data?.admission_no || '-' }}</p>
            </div>
            <div class="bg-gray-50 rounded-xl p-3.5 border border-gray-100 hover:border-purple-200 hover:bg-purple-50 transition-colors duration-150">
              <p class="text-xs text-gray-400 mb-1" [style.font-family]="'var(--vex-font)'">Father's Name</p>
              <p class="text-sm font-semibold text-gray-800 leading-snug" [style.font-family]="'var(--vex-font)'">{{ results?.student_result_details?.student_father_name || '-' }}</p>
            </div>
            <div class="bg-gray-50 rounded-xl p-3.5 border border-gray-100 hover:border-purple-200 hover:bg-purple-50 transition-colors duration-150">
              <p class="text-xs text-gray-400 mb-1" [style.font-family]="'var(--vex-font)'">Mother's Name</p>
              <p class="text-sm font-semibold text-gray-800 leading-snug" [style.font-family]="'var(--vex-font)'">{{ results?.student_result_details?.student_mother_name || '-' }}</p>
            </div>
          </div>
        </div>

        <div>
          <div class="flex items-center gap-2 mb-3">
            <span class="w-5 h-5 rounded-md bg-indigo-100 text-indigo-500 flex items-center justify-center text-xs flex-shrink-0">
              <i class="fa-solid fa-school"></i>
            </span>
            <span class="text-xs font-bold text-indigo-500 uppercase tracking-widest" [style.font-family]="'var(--vex-font)'">Academic Info</span>
          </div>
          <div class="grid grid-cols-2 md:grid-cols-4 gap-3">
            <div class="bg-gray-50 rounded-xl p-3.5 border border-gray-100 hover:border-indigo-200 hover:bg-indigo-50 transition-colors duration-150">
              <p class="text-xs text-gray-400 mb-1" [style.font-family]="'var(--vex-font)'">School</p>
              <p class="text-sm font-semibold text-gray-800 leading-snug" [style.font-family]="'var(--vex-font)'">{{ results?.student_data?.pcb_mapping?.school?.name || '-' }}</p>
            </div>
            <div class="bg-gray-50 rounded-xl p-3.5 border border-gray-100 hover:border-indigo-200 hover:bg-indigo-50 transition-colors duration-150">
              <p class="text-xs text-gray-400 mb-1" [style.font-family]="'var(--vex-font)'">Program</p>
              <p class="text-sm font-semibold text-gray-800 leading-snug" [style.font-family]="'var(--vex-font)'">{{ results?.student_data?.pcb_mapping?.program?.name || '-' }}</p>
            </div>
            <div class="bg-gray-50 rounded-xl p-3.5 border border-gray-100 hover:border-indigo-200 hover:bg-indigo-50 transition-colors duration-150">
              <p class="text-xs text-gray-400 mb-1" [style.font-family]="'var(--vex-font)'">Course</p>
              <p class="text-sm font-semibold text-gray-800 leading-snug" [style.font-family]="'var(--vex-font)'">{{ results?.student_data?.course?.name || '-' }}</p>
            </div>
            <div class="bg-gray-50 rounded-xl p-3.5 border border-gray-100 hover:border-indigo-200 hover:bg-indigo-50 transition-colors duration-150">
              <p class="text-xs text-gray-400 mb-1" [style.font-family]="'var(--vex-font)'">Branch</p>
              <p class="text-sm font-semibold text-gray-800 leading-snug" [style.font-family]="'var(--vex-font)'">{{ results?.student_data?.branch?.name || '-' }}</p>
            </div>
          </div>
        </div>

        <div>
          <div class="flex items-center gap-2 mb-3">
            <span class="w-5 h-5 rounded-md bg-green-100 text-green-600 flex items-center justify-center text-xs flex-shrink-0">
              <i class="fa-solid fa-chart-line"></i>
            </span>
            <span class="text-xs font-bold text-green-600 uppercase tracking-widest" [style.font-family]="'var(--vex-font)'">Result Summary</span>
          </div>
          <div class="grid grid-cols-2 md:grid-cols-4 gap-3">
            <div class="bg-gray-50 rounded-xl p-3.5 border border-gray-100 hover:border-green-200 hover:bg-green-50 transition-colors duration-150">
              <p class="text-xs text-gray-400 mb-1" [style.font-family]="'var(--vex-font)'">Semester</p>
              <p class="text-sm font-semibold text-gray-800 leading-snug" [style.font-family]="'var(--vex-font)'">{{ results?.student_result_details?.semester_year || '-' }}</p>
            </div>
            <div class="bg-gray-50 rounded-xl p-3.5 border border-gray-100 hover:border-green-200 hover:bg-green-50 transition-colors duration-150">
              <p class="text-xs text-gray-400 mb-1" [style.font-family]="'var(--vex-font)'">Batch</p>
              <p class="text-sm font-semibold text-gray-800 leading-snug" [style.font-family]="'var(--vex-font)'">{{ results?.student_result_details?.batch || '-' }}</p>
            </div>
            <div class="bg-gray-50 rounded-xl p-3.5 border border-gray-100 hover:border-green-200 hover:bg-green-50 transition-colors duration-150">
              <p class="text-xs text-gray-400 mb-1" [style.font-family]="'var(--vex-font)'">SGPA</p>
              <p class="text-sm font-semibold text-gray-800 leading-snug" [style.font-family]="'var(--vex-font)'">{{ results?.student_result_details?.sgpa || '-' }}</p>
            </div>
            <div class="bg-gray-50 rounded-xl p-3.5 border border-gray-100 hover:border-green-200 hover:bg-green-50 transition-colors duration-150">
              <p class="text-xs text-gray-400 mb-1" [style.font-family]="'var(--vex-font)'">CGPA</p>
              <p class="text-sm font-semibold text-gray-800 leading-snug" [style.font-family]="'var(--vex-font)'">{{ results?.student_result_details?.cgpa || '-' }}</p>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="card rounded-2xl shadow-sm overflow-hidden">
      <div class="flex items-center gap-3 px-6 py-4 border-b border-gray-100">
        <div class="w-9 h-9 rounded-full bg-purple-100 text-purple-600 flex items-center justify-center flex-shrink-0">
          <i class="fa-solid fa-book-open text-sm"></i>
        </div>
        <h2 class="text-base font-bold text-gray-800" [style.font-family]="'var(--vex-font)'">Subject Marks</h2>
        <span class="ml-auto text-xs text-gray-400 bg-gray-100 px-3 py-1 rounded-full" [style.font-family]="'var(--vex-font)'">
          {{ processedSubjects.length }} Subject{{ processedSubjects.length !== 1 ? 's' : '' }}
        </span>
      </div>

      <div class="table-scroll overflow-x-auto">
        <table class="min-w-full border-collapse">
          <thead>
            <tr class="bg-[#655BE7] text-white">
              <th class="px-5 py-4 text-center text-sm font-semibold whitespace-nowrap border-r border-purple-400" [style.font-family]="'var(--vex-font)'">S.No.</th>
              <th class="px-5 py-4 text-left text-sm font-semibold whitespace-nowrap border-r border-purple-400" [style.font-family]="'var(--vex-font)'">Subject Name</th>
              <th class="px-5 py-4 text-center text-sm font-semibold whitespace-nowrap border-r border-purple-400" [style.font-family]="'var(--vex-font)'">Credit</th>
              <th class="px-5 py-4 text-center text-sm font-semibold whitespace-nowrap border-r border-purple-400" [style.font-family]="'var(--vex-font)'">Subject Type</th>
              <th *ngFor="let mf of activeMarkFields"
                  class="px-5 py-4 text-center text-sm font-semibold whitespace-nowrap border-r border-purple-400"
                  [style.font-family]="'var(--vex-font)'">{{ mf.label }}</th>
              <th class="px-5 py-4 text-center text-sm font-semibold whitespace-nowrap border-r border-purple-400" [style.font-family]="'var(--vex-font)'">Total</th>
              <th class="px-5 py-4 text-center text-sm font-semibold whitespace-nowrap border-r border-purple-400" [style.font-family]="'var(--vex-font)'">Grade</th>
              <th class="px-5 py-4 text-center text-sm font-semibold whitespace-nowrap" [style.font-family]="'var(--vex-font)'">Status</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let subject of processedSubjects; let i = index; let odd = odd"
                class="border-b border-gray-100 hover:bg-purple-50 transition-colors duration-150"
                [ngClass]="odd ? 'bg-gray-50' : 'bg-white'">

              <td class="px-5 py-4 text-center text-sm text-gray-500 border-r border-gray-100" [style.font-family]="'var(--vex-font)'">{{ i + 1 }}</td>

              <td class="px-5 py-4 border-r border-gray-100 whitespace-nowrap">
                <p class="text-sm text-gray-800 font-medium" [style.font-family]="'var(--vex-font)'">{{ subject.name }}</p>
                <p class="text-xs text-[#655BE7] font-semibold mt-0.5" [style.font-family]="'var(--vex-font)'">{{ subject.code }}</p>
              </td>

              <td class="px-5 py-4 text-center text-sm text-gray-600 border-r border-gray-100" [style.font-family]="'var(--vex-font)'">{{ subject.credit }}</td>

              <td class="px-5 py-4 text-center border-r border-gray-100">
                <span class="text-sm bg-indigo-50 text-indigo-600 font-medium px-2 py-0.5 rounded-full whitespace-nowrap" [style.font-family]="'var(--vex-font)'">{{ subject.type }}</span>
              </td>

              <ng-container *ngFor="let mf of activeMarkFields">
                <td class="px-3 py-3 text-center border-r border-gray-100" style="min-width: 120px;">
                  <ng-container *ngIf="subject.markMap[mf.key] as mark; else noMark">
                    <div class="flex flex-col items-center gap-1.5">
                      <input [(ngModel)]="newMarks[mark.inputKey]"
                             type="number" min="0" [max]="mark.max"
                             (input)="clampMark(mark.inputKey, mark.max, $event)"
                             class="w-10 text-center text-xs border border-gray-200 rounded py-1.5 focus:outline-none focus:border-[#655BE7] focus:ring-1 focus:ring-[#655BE7] transition bg-white"
                             placeholder=""
                             [style.font-family]="'var(--vex-font)'"/>
                      <span class="text-xs text-gray-700" [style.font-family]="'var(--vex-font)'"><span class="font-bold">{{ mark.awarded }}</span> / {{ mark.max }}</span>
                    </div>
                  </ng-container>
                  <ng-template #noMark>
                    <span class="text-gray-400 text-sm">—</span>
                  </ng-template>
                </td>
              </ng-container>

              <td class="px-3 py-3 text-center border-r border-gray-100" style="min-width: 100px;">
                <div class="flex flex-col items-center gap-1.5">
                  <span class="text-sm font-bold text-[#655BE7]" [style.font-family]="'var(--vex-font)'">{{ getRevisedTotal(subject) }}</span>
                  <span class="text-xs text-gray-700" [style.font-family]="'var(--vex-font)'"><span class="font-bold">{{ subject.totalAwarded }}</span> / {{ subject.totalMax }}</span>
                </div>
              </td>

              <td class="px-5 py-4 text-center border-r border-gray-100">
                <span class="text-sm font-bold px-2 py-0.5 rounded"
                      [ngClass]="subject.grade === 'F' ? 'bg-red-100 text-red-600' : 'bg-indigo-100 text-indigo-700'"
                      [style.font-family]="'var(--vex-font)'">{{ subject.grade }}</span>
              </td>

              <td class="px-5 py-4 text-center">
                <span class="text-sm font-semibold px-2 py-0.5 rounded"
                      [ngClass]="subject.status === 'P' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'"
                      [style.font-family]="'var(--vex-font)'">{{ subject.status === 'P' ? 'Pass' : 'Fail' }}</span>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="card rounded-2xl shadow-sm p-6 mt-5">
      <label class="block text-xs font-bold text-gray-500 uppercase tracking-widest mb-2" [style.font-family]="'var(--vex-font)'">
        Examination Session
      </label>
      <input [(ngModel)]="examinationSession"
             type="text"
             placeholder="Please enter examination session"
             class="w-full text-sm text-gray-700 border border-gray-200 rounded-xl px-4 py-3 focus:outline-none focus:border-[#655BE7] focus:ring-1 focus:ring-[#655BE7] transition mb-5"
             [style.font-family]="'var(--vex-font)'"/>
      <label class="block text-xs font-bold text-gray-500 uppercase tracking-widest mb-2" [style.font-family]="'var(--vex-font)'">
        Remarks
      </label>
      <textarea [(ngModel)]="remarks" rows="3"
                placeholder="Enter reason for updating this result..."
                class="w-full text-sm text-gray-700 border border-gray-200 rounded-xl px-4 py-3 resize-none focus:outline-none focus:border-[#655BE7] focus:ring-1 focus:ring-[#655BE7] transition"
                [style.font-family]="'var(--vex-font)'"></textarea>
    </div>

    <div class="flex justify-end mt-5">
      <button (click)="update()" class="bg-[#655BE7] text-white hover:bg-purple-700 transition-colors duration-200 rounded px-6 py-2 text-sm font-medium"
              [style.font-family]="'var(--vex-font)'">
        <i class="fa-solid fa-pen-to-square mr-2"></i>Update
      </button>
    </div>

  </ng-container>
</div>
